/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAward } from '../../models/profile-award';

export interface ListProfileAwards$Params {
  id: number;
}

export function listProfileAwards(http: HttpClient, rootUrl: string, params: ListProfileAwards$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileAward>>> {
  const rb = new RequestBuilder(rootUrl, listProfileAwards.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileAward>>;
    })
  );
}

listProfileAwards.PATH = '/rest/profile/{id}/award';
